import React, { useEffect, useState } from 'react';
import styles from './rankCalculator.module.scss';
import BlockHeading from '@ui-kit/components/blockHeading';
import calculateRanks, { Result } from '../../helpers/calculateRank';
import RankDelta from '../common/rankDelta/rankDelta';
import { t } from '@base/utils/helpers';

type Ranks = {
  my?: number;
  opponent?: number;
};

export default function RankCalculator(props: { myRank?: number }) {
  const [ranks, setRanks] = useState<Ranks>({
    my: props.myRank,
    opponent: undefined,
  });
  const [result, setResult] = useState<Result>();

  useEffect(
    () =>
      setResult(
        ranks.my && ranks.opponent
          ? calculateRanks(ranks.my, ranks.opponent)
          : undefined
      ),
    [ranks]
  );

  useEffect(
    () => {
      props.myRank && setRanks({ ...ranks, my: props.myRank });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.myRank]
  );

  function updateRanks(key: string) {
    const MAX_LENGTH = 4;
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = e.target.value;
      if (value.length > MAX_LENGTH) value = value.slice(0, MAX_LENGTH);
      setRanks({ ...ranks, [key]: Number(value) || undefined });
    };
  }

  return (
    <div className={styles.calc}>
      <BlockHeading>{t('ladder_rank_calculator')}</BlockHeading>
      <div className={styles.form}>
        <div>
          <CalcFormField
            title={t('your_rank')}
            onChange={updateRanks('my')}
            value={ranks.my}
          />
          <CalcFormField
            title={t('opponent_rank')}
            onChange={updateRanks('opponent')}
            value={ranks.opponent}
          />
        </div>
        <div>
          <ResultCard result={result} />
        </div>
      </div>
    </div>
  );
}

function CalcFormField(props: {
  title: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: number;
}) {
  return (
    <div className={styles.formField}>
      <span>{props.title}:</span>
      <input type="number" onChange={props.onChange} value={props.value || ''} />
    </div>
  );
}

function ResultCard(props: { result?: Result }) {
  return (
    <div className={styles.resultCard}>
      <div className={styles.resultCard__content}>
        <div>
          <span>{t('you_win')}</span>
          <RankDelta
            start={props.result?.prevRank || '0'}
            finish={props.result?.winRank}
          />
        </div>
        <div>
          <span>{t('you_lose')}</span>
          <RankDelta
            start={props.result?.prevRank || '0'}
            finish={props.result?.loseRank}
          />
        </div>
      </div>
    </div>
  );
}
